/* Island Sunsets: when a shopper picks a combination that doesn't exist
   (e.g. 36x36 while Fine Art Canvas is selected), quietly switch the other
   options to the closest combination that does exist BEFORE the theme asks
   Shopify for it, so "Unavailable" never shows. The value they clicked is
   always kept. */
(function () {
  var cache = {};

  function clean(url) { return (url || '').split('?')[0]; }

  function load(url) {
    url = clean(url);
    if (!url || cache[url]) return;
    cache[url] = 'loading';
    fetch(url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[url] = p; })
      .catch(function () { delete cache[url]; });
  }

  function prefetch() {
    document.querySelectorAll('product-info[data-url]').forEach(function (pi) {
      load(pi.dataset.url);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefetch);
  } else {
    prefetch();
  }

  function area(s) {
    var m = /(\d+)\s*x\s*(\d+)/i.exec(s || '');
    return m ? m[1] * m[2] : 0;
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var vs = t.closest('variant-selects');
      var pi = t.closest('product-info');
      if (!vs || !pi) return;

      var p = cache[clean(pi.dataset.url)];
      if (!p || !p.variants) { load(pi.dataset.url); return; }

      var el = t.tagName === 'SELECT' ? t.selectedOptions[0] : t;
      if (!el || !el.dataset || !el.dataset.optionName) return;

      var names = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      var clickedIdx = names.indexOf(el.dataset.optionName);
      if (clickedIdx < 0) return;

      var cur = {};
      vs.querySelectorAll('input:checked').forEach(function (i) {
        if (i.dataset.optionName) cur[i.dataset.optionName] = i.value;
      });
      vs.querySelectorAll('select').forEach(function (s) {
        var o = s.selectedOptions[0];
        if (o && o.dataset.optionName) cur[o.dataset.optionName] = o.value;
      });
      cur[names[clickedIdx]] = el.value;

      var exists = p.variants.some(function (v) {
        return v.available && names.every(function (n, j) { return v.options[j] === cur[n]; });
      });
      if (exists) return;

      var sizeIdx = names.indexOf('Size');
      var curArea = sizeIdx >= 0 ? area(cur['Size']) : 0;
      var best = null, bestScore = -1, bestDist = Infinity;
      p.variants.forEach(function (v) {
        if (!v.available || v.options[clickedIdx] !== el.value) return;
        var score = 0;
        names.forEach(function (n, j) {
          if (j !== clickedIdx && cur[n] === v.options[j]) score += 1 << (names.length - j);
        });
        var dist = sizeIdx >= 0 ? Math.abs(area(v.options[sizeIdx]) - curArea) : 0;
        if (score > bestScore || (score === bestScore && dist < bestDist)) {
          best = v; bestScore = score; bestDist = dist;
        }
      });
      if (!best) return;

      names.forEach(function (n, j) {
        if (j === clickedIdx || cur[n] === best.options[j]) return;
        var want = best.options[j];
        vs.querySelectorAll('input[type="radio"]').forEach(function (i) {
          if (i.dataset.optionName === n) i.checked = (i.value === want);
        });
        vs.querySelectorAll('select').forEach(function (s) {
          Array.prototype.forEach.call(s.options, function (o) {
            if (o.dataset.optionName !== n) return;
            if (o.value === want) { o.selected = true; o.setAttribute('selected', 'selected'); }
            else { o.removeAttribute('selected'); }
          });
        });
      });
    },
    true
  );
})();

/* Safety net (original): if the theme still lands on a combination that
   doesn't exist, jump to the closest available one after the fact. */
(function () {
  var last = null;

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('variant-selects')) return;
      var el = t.tagName === 'SELECT' ? t.selectedOptions[0] : t;
      if (!el || !el.dataset) return;
      last = { name: el.dataset.optionName, value: el.value, id: t.id };
    },
    true
  );

  function patch() {
    var PI = customElements.get('product-info');
    if (!PI) return false;
    if (PI.prototype.__isAutoVariant) return true;

    var orig = PI.prototype.handleUpdateProductInfo;

    PI.prototype.handleUpdateProductInfo = function (productUrl) {
      var inner = orig.call(this, productUrl);
      var self = this;
      return function (html) {
        inner(html);
        if (self.getSelectedVariant(html)) return;
        self.__isFallback(productUrl);
      };
    };

    PI.prototype.__isFallback = async function (productUrl) {
      if (!last || this.__isBusy) return;
      this.__isBusy = true;
      try {
        var base = productUrl.split('?')[0];
        var p = await fetch(base + '.js').then(function (r) { return r.json(); });
        var names = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
        var idx = names.indexOf(last.name);
        if (idx < 0) return;

        var cur = {};
        this.querySelectorAll('variant-selects input:checked').forEach(function (i) {
          cur[i.dataset.optionName] = i.value;
        });
        this.querySelectorAll('variant-selects select').forEach(function (s) {
          var o = s.selectedOptions[0];
          if (o) cur[o.dataset.optionName] = o.value;
        });

        var sizeIdx = names.indexOf('Size');
        function area(s) {
          var m = /(\d+)\s*x\s*(\d+)/i.exec(s || '');
          return m ? m[1] * m[2] : 0;
        }
        var curArea = sizeIdx >= 0 ? area(cur['Size']) : 0;

        var best = null;
        var bestScore = -1;
        var bestDist = Infinity;
        p.variants.forEach(function (v) {
          if (!v.available || v.options[idx] !== last.value) return;
          var score = 0;
          names.forEach(function (n, j) {
            if (j !== idx && cur[n] === v.options[j]) score += 1 << (names.length - j);
          });
          var dist = sizeIdx >= 0 ? Math.abs(area(v.options[sizeIdx]) - curArea) : 0;
          if (score > bestScore || (score === bestScore && dist < bestDist)) {
            bestScore = score;
            bestDist = dist;
            best = v;
          }
        });
        if (!best) return;

        this.renderProductInfo({
          requestUrl: base + '?section_id=' + this.sectionId + '&variant=' + best.id,
          targetId: last.id,
          callback: this.handleUpdateProductInfo(base),
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.__isBusy = false;
      }
    };

    PI.prototype.__isAutoVariant = true;
    return true;
  }

  if (!patch() && window.customElements) customElements.whenDefined('product-info').then(patch);
})();